<!--
 * @Author: znn
 * @Date: 2021-04-20 11:57:04
 * @LastEditTime: 2021-04-21 14:12:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\orderDetails.vue
-->
<template>
  <div class="order_infos">
    <div class="orderbox">
      <div class="order_topcon">
        <p>{{orderDetails.order_status==0?'待支付':''||orderDetails.order_status==1?'待发货':''||orderDetails.order_status==2?'待收货':''||orderDetails.order_status==3?'已完成':''||orderDetails.order_status==4?'退款中':''||orderDetails.order_status==5?'退款审核成功':''||orderDetails.order_status==-1?'已取消':''}}</p>
        <div class="ordermoney">订单金额（含运费）：¥{{orderDetails.pay_money_dollar}}</div>
      </div>
      <!-- 物流信息-->
      <div class="order_adrress" v-if="orderDetails.child_order_num>0">
        <h2>详细信息</h2>
        <!--   begin   单条物流信息-->
        <div v-if="orderDetails.child_order_num==1">
          <div class="order_kd">
            <p>快递单号：{{express_no}}</p>
            <b class="red" @click="copyTextFg(express_no)">复制</b>
          </div>
          <div
            class="xx_adr"
            @click="goShipInfo(id,ship_info.express_no)"
            v-if="ship_info.express_no"
          >
            <div class="loc_adr">
              <span class="iconfont iconweizhi" style="size: 40px;color: #FF3D21"></span>
              <div class="logistics_city">
                <p class="order_size">{{ship_info.accept_station}}</p>
                <p class="time">时间:{{ship_info.accept_time}}</p>
              </div>
              <span class="iconfont iconarrow-right-bold" style="size: 32px;color: #999"></span>
            </div>
          </div>
        </div>
        <!--   end   单条物流信息-->
        <!--   begin   多条物流信息-->
        <div class="wl_info" v-else>
          <p>您有{{orderDetails.child_order_num}}条快递信息</p>
          <p class="view" @click="goShipInfo(id,express_no)">查看</p>
        </div>
        <!--   end   多条物流信息-->
      </div>
      <!--商品-->
      <div>
        <div class="order_goods" v-for="item in child_order_list" :key="item.id">
          <img :src="item.goods_image?item.goods_image:imgPath+'yj_defatult.png'" alt />
          <div>
            <p>{{item.goods_name}}</p>
            <b>{{item.sku_name}}</b>
            <strong>x{{item.num}}</strong>
            <span>
              <i>￥</i>
              {{ orderDetails.order_type == 1 ? item.market_price_dollar : item.goods_price_dollar}}
            </span>
          </div>
          <div
            class="apply"
            v-if="refundInfo.can_refund == 1 && !reimburse"
            @click="selectTypeFg"
          >申请售后</div>
        </div>
      </div>
      <div class="main8" v-if="orderDetails.order_type == 1 && orderDetails.order_status == 0">
        <div class="order_card">
          <p>提货卡</p>
          <p>{{orderDetails.gain_score}}</p>
        </div>
        <div class="n_timer">仅限提货专区使用 有效期两年</div>
      </div>
      <div class="order_x_info">
        <h2>详细信息</h2>
        <ul>
          <li>
            <p>订单编号</p>
            <p>{{orderDetails.order_no}}</p>
          </li>
          <li>
            <p>创建时间</p>
            <p>{{orderDetails.created_at_text}}</p>
          </li>
          <li v-if="orderDetails.pay_time_text">
            <p>支付时间</p>
            <p>{{orderDetails.pay_time_text}}</p>
          </li>
          <li v-if="orderDetails.pay_type==1">
            <p>支付方式</p>
            <p>{{orderDetails.pay_type_text}}</p>
          </li>
          <li v-if="orderDetails.order_status==2 || orderDetails.order_status==3">
            <p>发货时间</p>
            <p>{{orderDetails.consign_time_text}}</p>
          </li>
          <li v-if="orderDetails.order_status==2 || orderDetails.order_status==3">
            <p>收货时间</p>
            <p>{{orderDetails.sign_time_text}}</p>
          </li>
          <li>
            <p>收货地址</p>
            <p>{{orderDetails.receiver_name}} {{orderDetails.receiver_mobile}}</p>
          </li>
          <li>
            <p></p>
            <p>{{orderDetails.receiver_address}}</p>
          </li>
        </ul>
      </div>
      <div class="order_x_info">
        <h2>订单金额</h2>
        <ul>
          <li>
            <p>商品小计</p>
            <p>￥{{ orderDetails.order_type == 1 ? orderDetails.goods_market_all_money : orderDetails.goods_amount_dollar}}</p>
          </li>
          <li v-if="orderDetails.red_packet_price_dollar > 0">
            <p>红包抵扣</p>
            <p>-￥{{orderDetails.red_packet_price_dollar}}</p>
          </li>
          <li>
            <p>运费</p>
            <p>￥{{orderDetails.ship_amount_dollar}}</p>
          </li>
          <li>
            <p>实付费（含运费）</p>
            <p>￥{{ (orderDetails.order_status!= 0 && orderDetails.order_type == 1) ?orderDetails.ship_amount_dollar : orderDetails.pay_money_dollar}}</p>
          </li>
          <li v-if="orderDetails.order_type == 4 || orderDetails.order_type == 2">
            <p>提货卡</p>
            <p>{{orderDetails.score}}</p>
          </li>
          <!--        <li>-->
          <!--          <p>提货卡</p>-->
          <!--          <p>-￥8</p>-->
          <!--        </li>-->
          <li v-if="orderDetails.buyer_message!='' ">
            <p>留言</p>
            <p>{{orderDetails.buyer_message}}</p>
          </li>
        </ul>
      </div>
    </div>
    <!--    底部按钮-->
    <div class="orderfoot" v-if="refundInfo.can_refund == 1 && reimburse">
      <p class="button" @click="applicationFg">申请退款</p>
      <!-- <p class="button">申请退款</p> -->
    </div>
    <!-- v-if="orderDetails.order_status==2" -->
    <!-- <div class="orderfoot" v-if="orderDetails.order_status==2">
      <p class="button" @click="$router.push({path: './selectType'})">申请售后</p>
    </div>-->
    <!-- 选择售后原因 -->
    <van-action-sheet
      v-model="isShow"
      title="申请原因"
      cancel-text="取消"
      @cancel="onCancel"
      safe-area-inset-bottom
    >
      <div
        class="nm_content"
        v-for="item in actions"
        :key="item.id"
        @click="selectFg(item)"
      >{{item.name}}</div>
    </van-action-sheet>
    <!-- 选择售后类型 -->
    <van-action-sheet
      v-model="isShowType"
      title="售后类型"
      cancel-text="取消"
      @cancel="onCancel"
      safe-area-inset-bottom
    >
      <div
        class="nm_content"
        v-for="item in refundList"
        :key="item.id"
        @click="$router.push({path: './returnGoodsForm' ,query: {orderDetailId: id,refundId: item.id,orderId: orderDetails.id}})"
      >{{item.name}}</div>
    </van-action-sheet>
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog } from 'vant'
import { Toast } from 'vant'
import { copyText } from '../public/regular.js'
Vue.use(Toast)
export default {
  name: 'orderDetails',
  data() {
    return {
      order_no: '', //订单编号
      order_id: '', //订单id
      orderDetails: {}, //详情基本信息
      child_order_list: [], //订单商品信息
      ship_info: {}, //物流信息
      express_no: '', //物流单号
      isShow: false,
      isShowType: false,
      actions: [],
      cur: {}, //选择的原因
      refundInfo: {},
      refundList: [],
      reimburse: false,
    }
  },
  created() {
    this.order_no = this.$route.query.order_no
    this.order_id = this.$route.query.order_id
    this.id = this.$route.query.id
    console.log(this.order_no, '---')
  },
  mounted() {
    this.prohibitweixinShare()
    this.getOrderDetail() //获取订单详情
    this.getRefundList()
    this.getRefundType()
  },
  methods: {
    copyTextFg(text) {
      copyText(text)
    },
    selectTypeFg() {
      this.isShowType = true
    },
    onCancel() {
      this.isShow = false
    },
    selectFg(action) {
      console.log(action)
    },
    //获取订单详情
    getOrderDetail() {
      this.http('ClientOrder.childDetail', { order_id: this.id }).then(
        (res) => {
          if (res.status == 200) {
            console.log(res)
            this.orderDetails = res.content
            this.child_order_list = res.content.child_order_list
            let num = 0
            res.content.child_order_list.map((item) => {
              console.log(item.num)
            })
            this.getOrderExpressInfo() //物流跟踪信息
          } else {
            Toast(res.msg)
          }
        }
      )
    },
    //获取物流跟踪详情
    getOrderExpressInfo() {
      this.http('ClientOrder.getOrderExpressInfo', {
        order_id: this.order_id,
      }).then((res) => {
        console.log(res)
        if (res.status == 200) {
          this.ship_info = res.content.ship_info[0]
            ? res.content.ship_info[0].trace_info
            : ''
          this.express_no = res.content.express_no
          this.shipDetails = res.content[0]
          console.log(this.express_no)
        } else {
          // Toast(res.msg)
        }
      })
    },
    //查看物流详情
    goShipInfo(order_goods_id, express_no) {
      console.log(order_goods_id, express_no)
      // return false
      this.$router.push({
        path: '/orderShipInfo',
        query: { express_no: express_no, order_goods_id: order_goods_id },
      })
    },
    // 申请退款
    applicationFg() {
      // this.isShow = true
      let _this = this
      Dialog.confirm({
        message: '是否确定取消订单?',
      })
        .then(() => {
          _this
            .http('ClientOrder.refundOrder', {
              order_detail_id: _this.id,
            })
            .then((res) => {
              console.log(res)
              if (res.status == 200) {
                _this.getOrderDetail()
                _this.getRefundType()
                Toast('提交成功，请等待审核')
              } else {
                Toast(res.msg)
              }
            })
        })
        .catch(() => {})
    },
    // 获取售后原因
    async getRefundList() {
      let res = await this.http('ClientOrder.refundApplyCase', {
        order_detail_id: this.id,
        apply_type: '2',
      })
      this.actions = res.content
    },
    async getRefundType() {
      let res = await this.http('ClientOrder.getRefundType', {
        order_detail_id: this.id,
      })
      this.refundInfo = res.content
      if (res.content.can_refund == 1) {
        res.content.can_refund_type.map((item) => {
          if (item.id == 1) {
            this.reimburse = true
          } else {
            this.reimburse = false
          }
          if (item.id != 1) {
            this.refundList.push(item)
          }
        })
      }
      console.log(res)
    },
  },
}
</script>
<style scoped>
.order_infos .van-action-sheet__cancel {
  padding: 25px 0;
}
</style>
<style scoped lang="scss">
.nm_content {
  text-align: center;
  padding: 28px 0;
  font-size: 32px;
  color: #323233;
}
.orderbox {
  padding-bottom: 150px;
}
.time {
  padding-top: 10px;
  color: #999;
}
.wl_info {
  font-size: 28px;
  color: #333;
  display: flex;
  justify-content: space-between;
}
.wl_info p {
  color: #999;
}
.wl_info p:nth-child(2) {
  color: #f0240e;
}
</style>
<style lang="scss" scoped>
.order_infos {
  background: #f8f8f8
    url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yi_bg_order.png')
    no-repeat center top;
  background-size: 750px 259px;
  min-height: 100vh;
  .order_topcon {
    color: #fff;
    font-size: 38px;
    padding-top: 60px;
    p {
      line-height: 50px;
      // background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_time.png')
      // no-repeat 270px center;
      background-size: 50px 50px;
      text-align: center;
      text-indent: 1em;
      margin-bottom: 28px;
    }
    .ordermoney {
      font-size: 28px;
      text-align: center;
      padding-bottom: 38px;
    }
  }
  .order_card {
    display: flex;
    justify-content: space-between;
    border-radius: 14px;
    margin: 20px 20px;
    padding: 30px 20px;
    box-sizing: border-box;
    font-size: 32px;
    color: #ffffff;
  }
  .main8 {
    height: 188px;
    border-radius: 14px;
    background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_card@2x.png')
      no-repeat center;
    background-size: 100%;
    margin-top: 20px;
    margin-left: 20px;
    width: 710px;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .n_timer {
    font-size: 20px;
    color: rgba(255, 219, 195, 0.7);
    padding: 0 30px;
    margin-top: 44px;
  }
  .order_goods {
    position: relative;
    width: 710px;
    height: 188px;
    background: #ffffff;
    border-radius: 14px;
    margin: 0 20px;
    img {
      float: left;
      width: 140px;
      height: 140px;
      border-radius: 10px;
      margin: 20px;
      border: 1px solid #eee;
    }
    div {
      width: 460px;
      margin-top: 24px;
      float: left;
      p {
        width: 476px;
        font-size: 28px;
        color: #333333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 10px;
      }
      strong {
        font-size: 24px;
        color: #999;
        padding-left: 10px;
      }
      b {
        font-size: 24px;
        color: #999;
        padding: 4px 10px;
        background: #f2f2f2;
        border-radius: 8px;
        display: inline-block;
        margin-bottom: 10px;
      }
      span {
        display: block;
        color: #f0240e;
        font-size: 34px;
        i {
          font-size: 28px;
        }
      }
    }
    .apply {
      position: absolute;
      right: 20px;
      bottom: 20px;
      width: 158px;
      height: 54px;
      line-height: 54px;
      text-align: center;
      font-size: 26px;
      background: #ffffff;
      border-radius: 200px;
      border: 2px solid #dcdee0;
    }
  }
  .order_x_info {
    width: 710px;
    background: #ffffff;
    border-radius: 14px;
    margin: 20px auto 0;
    h2 {
      color: #333333;
      font-size: 28px;
      line-height: 72px;
      padding: 0 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
    ul {
      padding: 0 30px 20px;
      li {
        display: flex;
        justify-content: space-between;
        line-height: 80px;
        font-size: 28px;
        p:nth-child(2) {
          width: 400px;
          text-align: right;
        }
      }
    }
  }
  .order_adrress {
    width: 650px;
    background: #ffffff;
    border-radius: 14px;
    margin: 0 auto 20px;
    padding: 10px 30px 20px;
    h2 {
      color: #333333;
      font-size: 28px;
      line-height: 72px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
    .order_kd {
      color: #333333;
      font-size: 26px;
      display: flex;
      justify-content: space-between;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
    .xx_adr {
      //background: url("https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_icon-map.png") no-repeat left center;
      //background-size: 50px 50px;
      margin-top: 25px;
      font-size: 24px;
      .loc_adr {
        display: flex;
        justify-content: space-between;
        .iconfont {
          margin-top: 20px;
        }
        .logistics_city {
          width: 550px;
        }
      }
    }
  }
  .orderfoot {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 100px;
    background: #fff;
    border-top: 1px solid #eee;
    .button {
      float: right;
      margin-right: 20px;
      width: 200px;
      height: 64px;
      background: #ffffff;
      border-radius: 200px;
      border: 2px solid #dcdee0;
      text-align: center;
      font-size: 28px;
      line-height: 64px;
      margin-top: 14px;
    }
  }
}
</style>